import React, { useEffect, useRef, useState } from 'react';
import { CheckTicketContext } from './CheckTicketPopup';
import Scanner from '../barcodescanner/Scanner';
import Result from '../barcodescanner/Result';
import MessageInfo from '../common/MessageInfo';
import { vibrate } from '../utils/sport-effects';
import { labels } from '../data/labels';

function CheckTicketBarCodeScanner() {
    const checkTicketContext = React.useContext(CheckTicketContext);
    const [scanning, setScanning] = useState(false);
    const [isError,setIsError] = useState(false);
    //const [results, setResults] = useState([]);
    const results = useRef([]);
    const scannerRef = useRef(null);

    function setTicketId(ticketId){
        vibrate();
        checkTicketContext.setTicketId(ticketId);
    }

    function addResult(result){
        results.current = results.current && [...results.current,result]
        handleResults();
    }

    //If found at least two equals scan results
    function handleResults(){
        results.current && results.current.forEach(function(r,i){
            results.current.forEach(function(r2,i2){
                if(i!=i2){
                    if(r==r2){
                        setTicketId(r);
                    }
                }
            });
        });
    }

    function onError(){
        setIsError(true);
    }

    //If found at least two equals scan results
    /*useEffect(() => {
        results.forEach(function(r,i){
            results.forEach(function(r2,i2){
                if(i!=i2){
                    if(r==r2){
                        setTicketId(r);
                    }
                }
            });
        });
    }, [results]);*/
  
    useEffect(() => {
        setScanning(checkTicketContext.scannerStarted);
    }, []);

    try {
        return (isError?
            <MessageInfo message={labels['check_ticket.not_supported']} />
            :
            <div id="scannerPopupContainer">
                {/* <ul className="results">
                    {results.map((result) => (result.codeResult && <Result key={result.codeResult.code} result={result} />))}
                </ul> */}
                <div id="scannerContainer" ref={scannerRef} style={{position: 'relative'/*, border: '3px solid red'*/}}>
                    {/* <video style={{ width: window.innerWidth, height: 480, border: '3px solid orange' }}/> */}
                    <canvas className="drawingBuffer" style={{
                            position: 'absolute',
                            top: '0px',
                            // left: '0px',
                            // height: '100%',
                            // width: '100%',
                            //border: '3px solid green'
                    }} />
                    {scanning ? <Scanner scannerRef={scannerRef} onDetected={(result) => addResult( result)} onInitError={onError} /> : null}
                </div>
            </div>
        )
    }catch(err){
        return <MessageInfo message={labels['check_ticket.not_supported']} />
    }
   
}

export default CheckTicketBarCodeScanner;